import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { formatPublishedAt } from '../../../lib/format-date';
import type { ArticleCardData } from './ArticleCard';
import { SmartImage } from '../../../components/media/SmartImage';
import { CategoryLink } from '../../../components/CategoryLink';

type Tab = 'home' | 'profile' | 'contact';

const TABS: { key: Tab; label: string }[] = [
  { key: 'home', label: '24 ساعة' },
  { key: 'profile', label: 'تراند' },
  { key: 'contact', label: 'إقتصاد' },
];

export function Sidebar({
  newest,
  trending,
  economy,
}: {
  newest: ArticleCardData[];
  trending?: ArticleCardData[];
  economy?: ArticleCardData[];
}) {
  const [active, setActive] = useState<Tab>('home');
  const lists: Record<Tab, ArticleCardData[]> = {
    home: newest,
    profile: trending && trending.length ? trending : newest,
    contact: economy && economy.length ? economy : newest,
  };
  return (
    <div className="post_gallery_sidebar">
      <ul className="nav nav-pills" id="pills-tab" role="tablist">
        {TABS.map((t) => (
          <li className="nav-item" key={t.key}>
            <a
              href={`#pills-${t.key}`}
              className={`nav-link${active === t.key ? ' active' : ''}`}
              id={`pills-${t.key}-tab`}
              role="tab"
              aria-controls={`pills-${t.key}`}
              aria-selected={active === t.key}
              onClick={(e) => {
                e.preventDefault();
                setActive(t.key);
              }}
            >
              {t.label}
            </a>
          </li>
        ))}
      </ul>
      <div className="tab-content" id="pills-tabContent">
        {TABS.map((t) => (
          <div
            key={t.key}
            className={`tab-pane fade${active === t.key ? ' show active' : ''}`}
            id={`pills-${t.key}`}
            role="tabpanel"
            aria-labelledby={`pills-${t.key}-tab`}
          >
            <div className="post_gallery_items">
              {lists[t.key].map((item) => (
                <div className="gallery_item" key={item.id}>
                  <div className="gallery_item_thumb">
                    <SmartImage media={item.coverMedia} alt={item.title} />
                  </div>
                  <div className="gallery_item_content">
                    <div className="post-meta">
                      {item.category && (
                        <div className="meta-categories">
                          <CategoryLink slug={item.category.slug} name={item.category.name} />
                        </div>
                      )}
                      <div className="meta-date">
                        <span>{formatPublishedAt(item.publishedAt)}</span>
                      </div>
                    </div>
                    <h4 className="title">
                      <Link to="/articles/$slug" params={{ slug: item.slug }}>
                        {item.title}
                      </Link>
                    </h4>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
